import React from 'react';
import styled from 'styled-components';

interface SectionSpacingProps {
  readonly children: React.ReactNode;
  readonly spacingTop: boolean;
  readonly spacingBottom: boolean;
}

export function SectionSpacing({
  children,
  spacingTop,
  spacingBottom,
}: SectionSpacingProps): JSX.Element {
  return (
    <SectionSpacingWrapper
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
    >
      {children}
    </SectionSpacingWrapper>
  );
}

interface SectionSpacingWrapperProps {
  spacingTop: boolean;
  spacingBottom: boolean;
}

const SectionSpacingWrapper = styled.div<SectionSpacingWrapperProps>`
  padding-block-start: ${(props) =>
    props.spacingTop ? props.theme.brand.spacing.inputSectionVerticalGap : 0};
  padding-block-end: ${(props) =>
    props.spacingBottom
      ? props.theme.brand.spacing.inputSectionVerticalGap
      : 0};
`;
